import React, { useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';

function Login() {
  const [isLogin, setIsLogin] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    displayName: '',
    businessName: '',
    gstNumber: '',
    phone: ''
  });

  const { currentUser, signin, signup, resetPassword } = useAuth();
  const ownerEmail = process.env.REACT_APP_OWNER_EMAIL || '';

  if (currentUser) {
    return <Navigate to="/dashboard" />;
  }

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // In single-owner mode we don't allow signup

    setLoading(true);

    try {
      await signin(formData.email, formData.password);
      toast.success('Logged in successfully');
    } catch (error) {
      console.error('Authentication error:', error);
      toast.error(error.message || 'Authentication failed');
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    if (!formData.email) {
      return toast.error('Please enter your email address');
    }

    // Check if email is authorized
    const ownerEmail = process.env.REACT_APP_OWNER_EMAIL || 'bagheltelecom99@gmail.com';
    const salesManagerEmail = process.env.REACT_APP_SALES_MANAGER_EMAIL || 'a2ztak99@gmail.com';
    
    console.log('Owner Email:', ownerEmail);
    console.log('Sales Manager Email:', salesManagerEmail);
    console.log('Input Email:', formData.email);
    
    const isAuthorizedEmail = formData.email.toLowerCase() === ownerEmail.toLowerCase() || 
                             (salesManagerEmail && formData.email.toLowerCase() === salesManagerEmail.toLowerCase());
    
    console.log('Is Authorized:', isAuthorizedEmail);
    
    if (!isAuthorizedEmail) {
      return toast.error('This email is not authorized to access the system');
    }

    try {
      console.log('Sending password reset to:', formData.email);
      await resetPassword(formData.email);
      toast.success('Password reset email sent to your registered email');
    } catch (error) {
      console.error('Password reset error:', error);
      toast.error(error.message);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            {isLogin ? 'Sign in to your account' : 'Create your account'}
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            GST Management System for Small Business
          </p>
        </div>
        
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="rounded-md shadow-sm space-y-4">
            {/* Signup fields removed in single-owner mode */}
            
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email Address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="input mt-1"
                placeholder="Enter your email address"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                Password
              </label>
              <div className="mt-1 relative">
                <input
                  id="password"
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  autoComplete={isLogin ? 'current-password' : 'new-password'}
                  required
                  className="input pr-10"
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={handleChange}
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <EyeSlashIcon className="h-5 w-5 text-gray-400" />
                  ) : (
                    <EyeIcon className="h-5 w-5 text-gray-400" />
                  )}
                </button>
              </div>
            </div>
            
            {/* Confirm password removed */}
          </div>

          <div className="flex items-center justify-between">
            <button
              type="button"
              className="text-sm text-primary-600 hover:text-primary-500"
              onClick={handleForgotPassword}
            >
              Forgot your password?
            </button>
            
            {/* Signup toggle hidden in single-owner mode */}
          </div>

          <div>
            <button
              type="submit"
              disabled={loading}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? (
                <div className="spinner"></div>
              ) : (
                isLogin ? 'Sign in' : 'Create account'
              )}
            </button>
          </div>
        </form>
        
        <div className="text-center">
          <p className="text-xs text-gray-500">
            By signing up, you agree to our Terms of Service and Privacy Policy
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
